<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Active Report</el-breadcrumb-item>
      <el-breadcrumb-item>付费设备活跃分布</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="container">
      <div style="margin-bottom: 20px; margin-right: 20px; " size="medium">

        <el-radio-group v-model="radioType" style="margin-right: 20px; " size="medium">
          <el-radio-button label="pad">pad</el-radio-button>
          <el-radio-button label="app">app</el-radio-button>
          <el-radio-button label="all">all</el-radio-button>
          <el-radio-button label="xbike">xbike</el-radio-button>
          <el-radio-button label="litbike">litbike</el-radio-button>
          <el-radio-button label="boombike">boombike</el-radio-button>
          <el-radio-button label="boombasic">boombasic</el-radio-button>
          <el-radio-button label="ebike">ebike</el-radio-button>
          <el-radio-button label="other">other</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 只能选择月份 -->
      <label for="year-month">请选择查看月份:</label>

      <el-select v-model="selectedYearMonth" id="year-month" placeholder="请选择所需月份" @change="filterData">
        <el-option v-for="yearMonth in yearMonths" :key="yearMonth" :value="yearMonth"
          :label="formatYearMonth(yearMonth)"></el-option>
      </el-select>

      <div style=" margin-right: 80px; "> </div>

      <div>
        <!-- 提交按钮 -->
        <el-button type="primary" @click="getEngagement">获取活跃分布</el-button>
      </div>
      <div style=" margin-right: 80px; "> </div>

    </div>


    <div id="echart" style="height: 0;width: 90%; display: none;    margin: auto; "> </div>

    <el-table :data="tableData" stripe style="width: 100%" empty-text="由于运算量较大,请主动选择车型和时间区间后获取数据,并耐心等待几十秒!"
      :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="percentage" label="percentage" width="180" sortable> </el-table-column>

      <el-table-column prop="count" label="action count"> </el-table-column>
      <el-table-column prop="duration" label="duration/Min"></el-table-column>




    </el-table>


  </div>
</template>

<script>



export default {
  data() {
    return {
      selectedYearMonth: '',
      yearMonths: [], // 存储可选的年月列表
      tableData: [],
      radioType: 'pad',
    }
  },
  // 在 Vue 实例或组件中定义过滤器


  watch: {
    //watch  观察变化
    $route(newVal, oldVal) {
    },
  },
  created() {
    //console.log("created() ==>   完毕")
    this.initializeYearMonths();
    this.setDefaultSelectedYearMonth();

  },
  mounted() {
    this.pickerOptions.shortcuts[0].onClick({
      $emit: (event, payload) => {
        if (event === 'pick') {
          this.range = payload;
        }
      }
    });
  },





  methods: {
    async getEngagement() {  //getEngagement

      this.tableData = []

      //subs_active_percentage/:bike_type/:month
      let res = await this.$http.get("/da/subs_active_percential/" + this.radioType + "/" + this.selectedYearMonth)
      this.tableData = res.data
      // console.log(res.data)
      //渲染图表
      this.getLoadEcharts();
    },
    initializeYearMonths() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      const yearMonths = [];
      for (let year = 2022; year <= currentYear; year++) {
        const startMonth = (year === 2022) ? 1 : 1; // 从1月开始
        const endMonth = (year === currentYear) ? currentMonth - 0 : 12; // 到当前月的上个月为止
        for (let month = startMonth; month <= endMonth; month++) {
          let monthKey = `${year}年${month.toString().padStart(2, '0')}月`
          yearMonths.push(monthKey)
          // yearMonths.push(`${year}-${month.toString().padStart(2, '0')}`);
        }
      }
      this.yearMonths = yearMonths;
    },
    setDefaultSelectedYearMonth() {
      const currentDate = new Date();
      const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
      const year = previousMonth.getFullYear();
      const month = (previousMonth.getMonth() + 1).toString().padStart(2, '0');
      this.selectedYearMonth = `${year}年${month}月`;
    },
    filterData() {
      // 在这里可以添加筛选逻辑，根据选择的年月筛选数据
      //  先实现转移到url 中 
    },

    formatYearMonth(yearMonth) {
      // const [year, month] = yearMonth.split('-');
      //return `${year}年${month}月`;
      return yearMonth
    },
    getLoadEcharts() {

      var chart = this.$echarts.init(
        document.getElementById("echart")
      );


      document.getElementById('echart').style.height = '500px';
      document.getElementById('echart').style.display = 'block';
      // 重新渲染ECharts图表适应新的高度
      chart.resize();
      //进行数据预处理

      // 创建 dataChart 数组
      const dataChart = this.tableData.map(item => ({
        percentage: item.percentage,
        duration: item.duration,
        count: item.count,

      }));

      // if (dataChart.length > 50) {
      //   dataChart = dataChart.slice(dataChart.length - 50);
      //       }
      //console.log("data  option\n", dataChart);



      // 创建图表的配置项
      const options = {
        title: {
          text: '用户数据分布' // 添加标题
        },
        // 配置项的其他设置...
        xAxis: {
          // 设置横坐标轴的数据
          data: dataChart.map(item => item.percentage)
        },

        tooltip: {
          // 触发类型，默认数据项图形触发
          trigger: 'item',
          // 内容格式器，{a}、{b}、{c}分别代表系列名，数据项名称，数据值
          formatter: '{a} <br/>{b} : {c}'
        },
        legend: {
          // 添加图例
          data: ['count', 'duration/Min']
        },
        yAxis: [
          {
            // 第一个y轴（主y轴）
            type: 'value',
            name: '次数',
            min: 0, // 最小值
            max: 150, // 最大值
          },
          {
            // 第二个y轴（次y轴）
            type: 'value',
            name: '时长（分钟）',
            // 与第一个y轴对齐
            alignTicks: true,
            min: 0, // 最小值
            max: 1500, // 最大值
          }
        ],
        series: [
          {
            name: 'count',
            type: 'line',
            stack: '活跃次数',
            data: dataChart.map(item => item.count)
          },
          {
            name: 'duration/Min',
            type: 'line',
            stack: '活跃时长',
            data: dataChart.map(item => item.duration),
            yAxisIndex: 1, // 指定使用次坐标轴（索引为1的y轴）
          },


        ]
      };
      // 使用配置项显示图表
      chart.setOption(options);

    },

  },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}
</style>